module.exports = __webpack_public_path__ + "img/course-3.3e4bde58.png";